import React from 'react';
import * as S from './HotelCard.styles';
import PersuasionHoverText from '../PersuasionHoverText/PersuasionHoverText';
import BedIcon from '../../../../Icons/BedIcon';
import AmenitiesList from '../AmenitiesList/AmenitiesList';
import {appConfig} from '@stencil/hotels-config';
// import GoSafePersuation from '../GoSafePersuation/GoSafePersuation';
import GoSafeTagPersuasion from '../../../../../shared/pages/DetailsPage/components/HotelDetails/GoSafeTagPersuasion/GoSafeTagPersuasion';

const HotelCardPersuasionsBlock = ({
  aboveRatePlanPersuasion = [],
  navigateToDetailsPage,
  gaHandler,
  roomTypeName,
  amenitiesIndexApplicableForHotel = [],
  amenitiesListMapping,
  contentPersuasion1 = [],
  contentPersuasion2 = [],
  roomTypeStyles = {},
}) => {
  return (
    <S.PersuasionWrapperDiv>
      {(aboveRatePlanPersuasion && aboveRatePlanPersuasion.length > 0 && (
        <S.RoomTypeWrapperDiv>
          <PersuasionHoverText
            data={aboveRatePlanPersuasion}
            actionHandler={(item, text) => {
              item.utag[0].n = text;
              navigateToDetailsPage(item);
            }}
            direction="top"
            type="aboveRatePlanPersuasion"
            gaHandler={gaHandler}
            hasMainTextIcon
          />
        </S.RoomTypeWrapperDiv>
      )) ||
        null}

      {(roomTypeName && (
        <S.RoomTypeWrapperDiv>
          <S.RoomTypeIconWrapperSpan>
            <BedIcon />
          </S.RoomTypeIconWrapperSpan>
          <S.RoomTypeTextWrapper title={roomTypeName} {...roomTypeStyles}>
            {roomTypeName}
          </S.RoomTypeTextWrapper>
        </S.RoomTypeWrapperDiv>
      )) ||
        null}

      {(amenitiesIndexApplicableForHotel && amenitiesIndexApplicableForHotel.length > 0 && (
        <S.RoomTypeWrapperDiv>
          <AmenitiesList
            list={amenitiesIndexApplicableForHotel.map(item => amenitiesListMapping[item])}
          />
        </S.RoomTypeWrapperDiv>
      )) ||
        null}

      {contentPersuasion1 &&
        contentPersuasion1.length > 0 &&
        ((contentPersuasion1[0]?.tp === appConfig.persuasionsTemplateIds.goSafe && (
          <GoSafeTagPersuasion
            data={contentPersuasion1[0]}
            onCtaClick={navigateToDetailsPage}
            gaHandler={gaHandler}
            showFull={true}
            positionTop={true}
          />
        )) || (
          <S.RoomTypeWrapperDiv>
            <PersuasionHoverText
              data={contentPersuasion1}
              direction="top"
              actionHandler={item => {
                navigateToDetailsPage(item);
              }}
              type={
                contentPersuasion1[0]?.tp === appConfig.persuasionsTemplateIds.specialDeal
                  ? 'contentPersuasion2'
                  : 'contentPersuasion1'
              }
              gaHandler={gaHandler}
              hasMainTextIcon
            />
          </S.RoomTypeWrapperDiv>
        ))}
      {contentPersuasion2 &&
        contentPersuasion2.length > 0 &&
        ((contentPersuasion2[0]?.tp === appConfig.persuasionsTemplateIds.goSafe && (
          <GoSafeTagPersuasion
            data={contentPersuasion2[0]}
            onCtaClick={navigateToDetailsPage}
            gaHandler={gaHandler}
            showFull={true}
            positionTop={true}
          />
        )) || (
          <S.RoomTypeWrapperDiv>
            <PersuasionHoverText
              data={contentPersuasion2}
              direction="top"
              actionHandler={item => {
                navigateToDetailsPage(item);
              }}
              type="contentPersuasion2"
              gaHandler={gaHandler}
              hasMainTextIcon
            />
          </S.RoomTypeWrapperDiv>
        ))}
      {/* {(contentPersuasion2 && contentPersuasion2.length > 0 && (
        <S.RoomTypeWrapperDiv>
          <PersuasionHoverText
            data={contentPersuasion2}
            direction="top"
            actionHandler={item => {
              navigateToDetailsPage(item);
            }}
            type="contentPersuasion2"
            gaHandler={gaHandler}
            hasMainTextIcon
          />
        </S.RoomTypeWrapperDiv>
      )) ||
        null} */}
    </S.PersuasionWrapperDiv>
  );
};

export default HotelCardPersuasionsBlock;
